<template>
 <div class="appointmentcontainer pb100">
  <banner/>
  <crumbs/>
  <div class="container">
    <type-screen modelType="managementdeclaration"
      :menu-id="this.$route.query.columnId"
      :fixed-type-list="fixedTypeList"
      @typeObj="selectType"/>
<ul class="ul-model1 clearfix declar">
    <li v-for="item in dataList" :key="item.id" @click="gotoDetail(item.id)">
      <img :src="getImage(item.image)" alt="">
      <div class="title">{{item.declareName}}</div>
    </li>

</ul>
<nodata v-show="nodataflag"/>
 <el-pagination
      @current-change="handleCurrentChange"
      :page-size="params.limit"
      :pager-count="5"
      :current-page.sync="currentPage"
      layout="prev, pager, next"
      :total="listTotal"
      class="pagemodel1">
    </el-pagination>
 </div>
 </div>
</template>

<script>

import {getDeclareList} from '@/api/declare/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'managementdeclaration',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    banner,
    nodata

  },
  data () {
    return {
      nodataflag: false,
      currentPage: 1,
      listTotal: 0,
      menuId: '',
      params: {
        page: 1,
        limit: 8,
        menuId: '',
        types: null,
        time: null,
        status: null,
        recommend: null
      },
      dataList: [],
      fixedTypeList: [{
        'id': 1,
        'name': '时间',
        'fixedtypeId': 1,
        'fixedtypename': 'time',
        'showFlag': 0,
        'children': [{
          'id': 1,
          'name': '全部',
          'code': ''
        }, {
          'id': 2,
          'name': '2021',
          'code': 2021
        }, {
          'id': 3,
          'name': '2020',
          'code': 2020
        }, {
          'id': 4,
          'name': '2019',
          'code': 2019
        }]
      }, {
        'id': 2,
        'name': '状态',
        'fixedtypeId': 2,
        'fixedtypename': 'status',
        'showFlag': 0,
        'children': [{
          'id': 1,
          'name': '全部',
          'code': ''
        }, {
          'id': 2,
          'name': '未开始',
          'code': 1
        }, {
          'id': 3,
          'name': '进行中',
          'code': 2
        }, {
          'id': 4,
          'name': '已结束',
          'code': 3
        }]
      }]
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.params.menuId = this.$route.query.columnId
    this.getList()
  },
  methods: {
    getList () {
      getDeclareList(this.menuId, this.params).then(res => {
        console.log(res)
        this.listTotal = res.data.totalSize
        this.dataList = res.data.data
      })
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.dataList = []
      this.getList()
    },
    /* 筛选条件 */
    selectType (obj) {
      console.log(obj)
      this.params.types = obj.customTypeId
      this.params.time = obj.time
      this.params.status = obj.status
      this.params.page = 1
      this.currentPage = 1
      this.dataList = []
      this.getList()
    },
    gotoDetail (id) {
      this.$router.push({
        path: '/managementdeclarationDetail',
        query: {
          id,
          columnId: this.menuId
        }
      })
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/declare.scss';
</style>



// WEBPACK FOOTER //
// src/view/managementdeclaration/list.vue